<script lang="ts">
  // An activity description clamped to a couple of lines, with the truncation itself as the
  // affordance: click the text (or the trailing "more") to expand it in place.
  import { tick } from 'svelte';
  import { cn } from '@/lib/utils';

  export let text: string = '';
  export let lines: number = 2;

  let expanded = false;
  let element: HTMLElement | null = null;
  let overflowing = false;

  // Re-measure whenever anything that changes the wrap changes -- including the card's own width,
  // which the resize observer below reports.
  let size: ResizeObserverSize[] | null = null;
  $: text, lines, size, measure();

  async function measure() {
    await tick();
    if (!element || expanded) return;
    overflowing = element.scrollHeight - element.clientHeight > 1;
  }

  function toggle(event: Event) {
    // The whole card is a click target on the dashboards; expanding a description isn't opening it.
    event.stopPropagation();
    expanded = !expanded;
  }
</script>

{#if text}
  <!-- The toggle sits on the last line, next to the ellipsis the clamp draws, rather than on a row
       of its own. Every line reserves a right-hand gutter for it (pr-12), so it never has to be
       masked against a background the card changes on hover. -->
  <div class="relative min-w-0" bind:borderBoxSize={size}>
    <!-- The button is the accessible way in; clicking the clamped text itself is a shortcut. -->
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
    <p
      bind:this={element}
      class={cn(
        'text-sm leading-5 text-muted-foreground m-0 whitespace-pre-line',
        overflowing ? 'pr-12' : '',
        overflowing && !expanded ? 'cursor-pointer' : ''
      )}
      style={expanded ? '' : `display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:${lines};overflow:hidden;`}
      on:click={(event) => { if (overflowing && !expanded) toggle(event); }}
    >{text}</p>
    {#if overflowing}
      <button
        type="button"
        class="absolute bottom-0 right-0 h-5 leading-5 bg-transparent border-0 p-0 text-xs text-primary hover:underline cursor-pointer"
        on:click={toggle}
      >
        {expanded ? 'less' : 'more'}
      </button>
    {/if}
  </div>
{/if}
